import { SfLog } from '@app/adapters/logger'
import sfetch from '@app/utils/sfetch'
import { onDocumentEvent } from '@app/utils/domHelpers'

const loadNextPeriodDetails = async (e) => {
  e.preventDefault()
  const option = e.target.closest('[data-behaviour~="details-period-option"]')
  const { url, currentLedgerId } = option.dataset

  if (url && currentLedgerId) {
    const copyActions = document.querySelector(
      '[data-testid="comparative-actions"] sf-ce-dropdown-wrapper'
    )
    copyActions?.setAttribute('is-disabled', 'true')

    try {
      const responseText = await sfetch.html(url, {
        method: 'POST',
        body: {
          current_ledger_id: currentLedgerId,
        },
      })

      const detailSection = document.querySelector('.detail-section')

      window.requestAnimationFrame(() => {
        detailSection.innerHTML = ''
        detailSection.insertAdjacentHTML('afterbegin', responseText)
      })
    } catch (e) {
      copyActions?.removeAttribute('is-disabled')
      SfLog.error('Error during loading next period details', {
        error: e,
      })
    }
  }
}

onDocumentEvent(
  document,
  'click',
  '[data-behaviour~="details-period-option"]',
  loadNextPeriodDetails
)
